import React from 'react';
import RootLayout from 'common/layout/root-layout';
import { Divider, Header, Grid } from 'semantic';
import Breadcrumbs from 'components/Breadcrumbs';

import Table from './Table';

import { useTranslation } from 'react-i18next';

export default function SyncLogIssuesWrapper() {
  const { t } = useTranslation();
  return (
    <RootLayout>
      <Breadcrumbs active={t('syncLogIssues.title', 'Sync Issues')} />
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Header as="h2" style={{ margin: '0' }}>
            {t('syncLogIssues.title', 'Sync Issues')}
          </Header>
        </Grid.Column>
      </Grid>
      <Divider hidden />
      <Divider hidden />
      <Table />
    </RootLayout>
  );
}
